
import { Component, PropSync } from "vue-property-decorator";
import BaseView from "@/views/BaseView.vue";
import BindSolanaWalletView from "./BindSolanaWalletView.vue";

@Component({
  components: { BindSolanaWalletView },
})
export default class BindSolanaWalletDialog extends BaseView {
  // 🚩 Flag which determines whether the dialog should be shown
  @PropSync("showDialog", { type: Boolean })
  public show!: boolean;
}
